<template>
  <div class="add-resource">
    <Card>
      <!--      <h2 v-if="status === 'add'" style="text-align: center;margin:20px 0 0 0;">新增物资</h2>-->
      <!--      <h2 v-else style="text-align: center;margin:20px 0 0 0;">修改物资</h2>-->
      <!--      <Divider/>-->
      <div style="width: 90%;margin: 0 auto">
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="150">
          <FormItem label="物资名称" prop="name">
            <Select transfer clearable v-model="formValidate.configId" placeholder="请填写物资名称" @on-change="isHaveGood">
              <Option v-for="(item,index) in nameList" :key="index" :label="item.name" :value="item.id"></Option>
            </Select>
          </FormItem>
          <!--          <FormItem label="存储仓库" prop="responsibleUnitId">-->
          <!--            <Select v-model="formValidate.responsibleUnitId" placeholder="请选择存储仓库">-->
          <!--              <Option value="1">1</Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="物资大类" prop="responsibleUnitId">-->
          <!--            <Select v-model="formValidate.responsibleUnitId" placeholder="请选择物资大类">-->
          <!--              <Option value="1">1</Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="物资小类" prop="responsibleUnitId">-->
          <!--            <Select v-model="formValidate.responsibleUnitId" placeholder="请选择物资小类">-->
          <!--              <Option value="1">1</Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->
          <FormItem label="数量" prop="number">
            <InputNumber v-model="formValidate.number" placeholder="请填写数量"></InputNumber>
          </FormItem>
          <!--          <FormItem label="计量单位" prop="unit">-->
          <!--            <Input v-model="formValidate.unit" placeholder="请填写单位"></Input>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="有效期限" prop="effectiveDate">-->
          <!--            <DatePicker type="date" placeholder="请选择有效期限" v-model="formValidate.effectiveDate"></DatePicker>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="失效预警提示时间" prop="responsibleUnitId">-->
          <!--            <Select v-model="formValidate.responsibleUnitId">-->
          <!--              <Option value="1">1</Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="出厂日期" prop="establishedTime">-->
          <!--            <DatePicker type="date" placeholder="请选择出厂日期" v-model="formValidate.establishedTime"></DatePicker>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="规格型号" prop="dutyTelephone">-->
          <!--            <Input v-model="formValidate.dutyTelephone" placeholder="请填写规格型号"></Input>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="适用事件类型" prop="applicableEventTypes">-->
          <!--            <Select transfer v-model="formValidate.applicableEventTypes" placeholder="请选择适用事件类型">-->
          <!--              <Option v-for="(item, index) in eventList" :value="item.id" :key="index">{{ item.name }}</Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="所属队伍" prop="responsibleUnitId">-->
          <!--            <Select v-model="formValidate.responsibleUnitId">-->
          <!--              <Option value="1">1</Option>-->
          <!--            </Select>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="主要参数" prop="countPeople">-->
          <!--            <Input v-model="formValidate.countPeople" placeholder="请填写主要参数"></Input>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="生产厂商" prop="address">-->
          <!--            <Input v-model="formValidate.address" placeholder="请填写生产厂商"></Input>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="登记日期" prop="establishedTime">-->
          <!--            <DatePicker type="date" placeholder="请选择出厂日期" v-model="formValidate.establishedTime"></DatePicker>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="编号" prop="dutyTelephone">-->
          <!--            <Input v-model="formValidate.dutyTelephone" placeholder="请填写规格型号"></Input>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="备注" prop="remark">-->
          <!--            <Input v-model="formValidate.remark" type="textarea" :autosize="{minRows: 3}"/>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="附件" prop="annex">-->
          <!--            <Input v-model="formValidate.annex" type="textarea"/>-->
          <!--          </FormItem>-->
          <!--          <FormItem label="照片" prop="annex">-->
          <!--            <Input v-model="formValidate.annex" type="textarea"/>-->
          <!--          </FormItem>-->
          <!--          <FormItem>-->
          <!--            <Button v-if="status === 'add'" type="primary" @click="handleSubmit('formValidate')">新增</Button>-->
          <!--            <Button v-if="status === 'edit'" type="primary" @click="editTeam('formValidate')">编辑</Button>-->
          <!--            <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>-->
          <!--          </FormItem>-->
        </Form>
        <div style="text-align: center">
          <Button v-if="status === 'add'" type="primary" :loading="saveLoading" @click="handleSubmit('formValidate')">
            新增
          </Button>
          <Button v-if="status === 'edit'" type="primary" :loading="saveLoading" @click="editTeam('formValidate')">
            编辑
          </Button>
          <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
export default {
  name: "addEmResource",
  props: {
    belongStore: {
      type: Number,
      default: 0
    },
    formValidate: {
      type: Object,
      default: () => {
        return {
          id: ''
          // name: '',
          // number: 0,
          // unit: '',
          // remark: '',
          // effectiveDate: ''
        }
      }
    },
    status: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameList: [],
      saveLoading: false,
      eventList: [],
      resourceInfo: {},
      // formValidate: {
      //   name: '',
      //   number: 0,
      //   unit: '',
      //   remark: '',
      //   effectiveDate: '',
      // },
      ruleValidate: {}
    }
  },
  mounted() {
    this.getAllEvents()
    this.getAllName()
    // console.log('1', this.formValidate)
    if (this.formValidate.id) {
      this.resourceInfo = this.formValidate
      this.resourceInfo.applicableEventTypes = this.formValidate.applicableEventTypes.toString()
      this.formValidate = this.resourceInfo
      this.formValidate.name = this.formValidate.configId
    }
  },
  methods: {
    // 判断否已添加
    isHaveGood(value) {
      console.log(value)
      let params = {
        belongStore: this.belongStore,
        configId: value
      }
      this.$http.post('/api/goods/judgeContainGoods', params).then(res => {
        console.log(res)
        if (res.data.message.length > 4) {
          this.$Message.warning({
            content: '该资源已存在！',
            duration: 3
          })
          this.formValidate.configId = null
          this.$emit("closeModal");
        }
      })
    },
    // 获取物资名称列表
    getAllName() {
      this.$http.post('/api/goodsConfig/getAll', {}).then(res => {
        this.nameList = res.data.data.list
      })
    },
    //获取事件类型/api/event/getAll
    getAllEvents() {
      this.$http.get('/api/event/getAll').then(res => {
        this.eventList = res.data.data
        // this.eventList = this.eventList.Map(item => item.id = Number(item.id))
      })
    },
    handleSubmit(name) {
      this.formValidate.belongStore = this.belongStore
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          let requestData = {
            number: this.formValidate.number,
            configId: this.formValidate.configId,
            belongStore: this.formValidate.belongStore
          }
          // console.log(requestData)
          this.$http.post('/api/goods/goodsAndMaterialss', requestData).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('新增完成！')
              this.saveLoading = false
              // 关闭
              this.$emit("closeModal");
              this.$refs[name].resetFields();
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    editTeam(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          let requestData = {
            ...this.formValidate,
            configId: this.formValidate.configId
          }
          this.$http.put('/api/goods/goodsAndMaterialss', requestData).then(res => {
            if (res.status === 200 || res.status === 201) {
              this.$Message.success('编辑完成！')
              this.saveLoading = false
              // 关闭
              this.$emit("closeModal", this.formValidate.belongStore);
            } else {
              this.$Message.error(res.data.message)
            }
          })
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    }
  }
}
</script>

<style scoped lang="less">
.add-resource {

}
</style>
